import { useEffect, type ReactNode } from "react";

export function Sheet({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40">
      <button
        aria-label="Schließen"
        onClick={onClose}
        className="sheet-backdrop absolute inset-0 bg-ink-900/35"
      />
      <div className="sheet-panel absolute inset-x-0 bottom-0 max-h-[88vh] overflow-y-auto rounded-t-3xl bg-cream-50 pb-[calc(1.5rem+env(safe-area-inset-bottom))] shadow-[0_-12px_40px_rgba(43,29,35,0.22)] dark:bg-night-surface">
        <div className="mx-auto mt-2.5 h-1.5 w-10 rounded-full bg-cream-200 dark:bg-night-border" />
        <div className="px-5 pb-1 pt-4">
          <div className="flex items-center justify-between">
            <h2 className="font-display text-xl font-semibold text-plum-900 dark:text-night-accent">{title}</h2>
            <button
              onClick={onClose}
              aria-label="Schließen"
              className="-mr-1.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-ink-400 dark:text-night-faint"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4.5 w-4.5">
                <path d="M6 6l12 12M18 6 6 18" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
          <div className="mt-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
